import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SettingsInitialState } from './types';

export enum DataNames {
  ANALYTICS_OVERVIEW_FAVORITES = 'ANALYTICS_OVERVIEW_FAVORITES',
  LAST_FARM_SELECTED = 'LAST_FARM_SELECTED',
  IS_SHOP_2021_MESSAGE_SHOWN = 'IS_SHOP_2021_MESSAGE_SHOWN',
  NOTIFICATIONS_LAST_READ_AT = 'NOTIFICATIONS_LAST_READ_AT',
  BASF_CONSENT = 'BASF_CONSENT',
  ZENNOH_CONSENT = 'ZENNOH_CONSENT',
  YARA_CONSENT = 'YARA_CONSENT',
  LAST_TERMINAL_SELECTED = 'LAST_TERMINAL_SELECTED',
  LAST_XCONNECT_SELECTED = 'LAST_XCONNECT_SELECTED',
  LAST_SELECTED_EXPORT_FILE_FORMAT = 'LAST_SELECTED_EXPORT_FILE_FORMAT',
  KEEP_DATA_CONSENT = 'KEEP_DATA_CONSENT',
  LAST_SELECTED_DISTRIBUTOR = 'LAST_SELECTED_DISTRIBUTOR',
  LAST_SELECTED_PREFECTURE = 'LAST_SELECTED_PREFECTURE',
  AG_DASHBOARD_CONFIGURATION = 'AG_DASHBOARD_CONFIGURATION',
  HF_DASHBOARD_CONFIGURATION = 'HF_DASHBOARD_CONFIGURATION',
  MFEV_CONFIGURATION = 'MFEV_CONFIGURATION',
  STATUS_PAGE_SELECTED_MAP_TYPE = 'STATUS_PAGE_SELECTED_MAP_TYPE',
  WEIGHTING_MODE = 'weightingMode',
  TIME_WEIGHTING = 'timeWeighting',
  GRID_SIZE_M = 'gridSizeM',
}

interface SetSettingProps {
  settingName: DataNames;
  settingValue: string;
  settingLastUpdated?: string;
}

export const initialState: SettingsInitialState = {
  data: [],
  status: 'idle',
  error: {},
  errorCode: undefined,
};

const userSettingsSlice = createSlice({
  name: 'users@settings',
  initialState,
  reducers: {
    requestStart(state) {
      state.status = 'loading';
    },
    requestSuccess(state, { payload }) {
      state.status = 'success';
      state.error = {};
      state.data = payload;
    },
    requestFailure(state, { payload }) {
      state.status = 'failure';
      state.error = payload;
      state.data = undefined;
    },
    setSetting: (state, action: PayloadAction<SetSettingProps>) => {
      const { settingName, settingValue, settingLastUpdated } = action.payload;

      const dataPoint = state.data?.find(
        (dataPoint) => dataPoint.name === settingName,
      );

      const otherDataPoints =
        state.data?.filter((dataPoint) => dataPoint.name !== settingName) || [];

      if (!dataPoint) return;

      dataPoint.value = settingValue;

      if (settingLastUpdated) {
        dataPoint.lastUpdated = settingLastUpdated;
      }

      state.data = [dataPoint, ...otherDataPoints];
    },
    resetSettings: (state) => {
      state.data = [];
      state.status = 'idle';
      state.error = {};
    },
  },
});

export { userSettingsSlice };
